import styled from "styled-components";
import { media } from "theme/breakpoints";

/** using theme provider */
export const PageTitle = styled.h1`
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textGray.darker};

  ${({ theme }) => theme.media["md"]} {
    font-size: 1.375rem;
  }
`;

export const CardTitle = styled.h3`
  color: ${({ theme }) => theme.colors.textGray.darker};
  font-size: 1rem;
  line-height: 1;
  margin: 0.25rem 0;
  font-weight: bold;

  ${media["md"]} {
    font-size: 1.0625rem;
  }
`;

export const SecondaryTitle = styled.h3`
  font-weight: 500;
  font-size: 10px;
  line-height: 13px;
  text-transform: uppercase;
  color: #737373;
  letter-spacing: 0.05em;
`;
